import React from "react";
import Cookies from "universal-cookie";
import Button from "./Button";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import ImageSilentInput from "./ImageSilentInput";
import Utils from "../utils/utils";
import loadDocument from "../services/loadDocument";
import checkTokenService from "../services/checkToken";
import LoadingOverlay from "react-loading-overlay";
import { Delete as DeleteIcon } from "@material-ui/icons";
import sendCompiti from "../services/sendCompiti";
import zIndex from "@material-ui/core/styles/zIndex";

export default class UploadCompiti extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titolo: "",
      descrizione: "",
      data: "",
      file: undefined,
      alertTitolo: false,
      alertDescrizione: false,
      alertData: false,
      alertFile: false,
      isLoading: false,
      loadingMessage: "Caricamento in corso...",
      visible: this.props.show !== false,
      uploadProgress: 0, // Progress bar
      isUploading: false, // Flag upload in corso
    };
    // Limite di 80MB per i file
    this.MAX_FILE_SIZE = 80 * 1024 * 1024;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({ visible: this.props.show !== false });
    }
  }

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div>
        <div style={container}>
          <div style={mainClass} onClick={(e) => e.stopPropagation()}>
            {this.state.isLoading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "400px",
                  padding: "40px",
                }}
              >
                <LoadingOverlay
                  active={true}
                  styles={{
                    overlay: (base) => ({
                      ...base,
                      background: "rgba(255, 255, 255, 0.95)",
                      position: "static",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }),
                    spinner: (base) => ({
                      ...base,
                      width: "80px",
                      "& svg circle": {
                        stroke: "#c41e3a",
                      },
                    }),
                    content: (base) => ({
                      ...base,
                      position: "static",
                      marginTop: "20px",
                      color: "#333",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }),
                  }}
                  spinner
                  text={this.state.loadingMessage}
                >
                  <div style={{ height: "200px" }} />
                </LoadingOverlay>

                {/* Progress bar durante upload */}
                {this.state.isUploading && (
                  <div
                    style={{
                      marginTop: "20px",
                      padding: "20px",
                      backgroundColor: "white",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "10px",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      {this.state.uploadProgress < 95 &&
                        "📤 Caricamento compito..."}
                      {this.state.uploadProgress >= 95 &&
                        this.state.uploadProgress < 100 &&
                        "⏳ Elaborazione..."}
                      {this.state.uploadProgress === 100 && "✅ Completato!"}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "25px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "12px",
                        overflow: "hidden",
                        border: "1px solid #ddd",
                      }}
                    >
                      <div
                        style={{
                          width: `${this.state.uploadProgress}%`,
                          height: "100%",
                          backgroundColor:
                            this.state.uploadProgress === 100
                              ? "#4caf50"
                              : "#c41e3a",
                          transition:
                            "width 0.3s ease, background-color 0.3s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          {this.state.uploadProgress}%
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div
                  style={closeBtn}
                  onClick={() => {
                    this.setState({ visible: false });
                    this.props.onClose();
                  }}
                >
                  ❌
                </div>
                <div style={windowTitle}>Assegna compito</div>
                <br />
                <input
                  style={input}
                  type="text"
                  placeholder="Titolo"
                  value={this.state.titolo}
                  onChange={(e) => {
                    this.setState({
                      titolo: e.target.value,
                      alertTitolo: false,
                    });
                  }}
                />
                {this.state.alertTitolo && (
                  <div style={alertStyle}>❗ Inserisci un titolo</div>
                )}
                <br />
                <textarea
                  style={textarea}
                  placeholder="Descrizione"
                  value={this.state.descrizione}
                  onChange={(e) => {
                    this.setState({
                      descrizione: e.target.value,
                      alertDescrizione: false,
                    });
                  }}
                />
                {this.state.alertDescrizione && (
                  <div style={alertStyle}>❗ Inserisci una descrizione</div>
                )}
                <br />
                <p
                  style={{
                    color: "darkgrey",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  Data di consegna
                </p>
                <input
                  style={input}
                  type="date"
                  value={this.state.data}
                  onChange={(e) => {
                    this.setState({ data: e.target.value, alertData: false });
                  }}
                />
                {this.state.alertData && (
                  <div style={alertStyle}>❗ Inserisci una data</div>
                )}
                <br />
                <ImageSilentInput
                  name={""}
                  value={this.state.file}
                  onChange={async (base64, fileInfo) => {
                    // Verifica dimensione file
                    if (fileInfo && fileInfo.size > this.MAX_FILE_SIZE) {
                      alert(
                        `Il file è troppo grande (${(
                          fileInfo.size /
                          1024 /
                          1024
                        ).toFixed(2)} MB). ` +
                          `La dimensione massima consentita è 80 MB.`
                      );
                      return;
                    }

                    // Mostra un messaggio di attesa per file grandi
                    if (fileInfo && fileInfo.size > 5 * 1024 * 1024) {
                      this.setState({
                        file: base64,
                        alertFile: false,
                        loadingMessage: `Preparazione file (${(
                          fileInfo.size /
                          1024 /
                          1024
                        ).toFixed(2)} MB)...`,
                      });
                    } else {
                      this.setState({ file: base64, alertFile: false });
                    }
                  }}
                />
                {this.state.alertFile && (
                  <div style={alertStyle}>❗ Inserisci un file</div>
                )}
                {this.state.file && (
                  <div style={fileStyle}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={require("../images/folder.png")}
                        style={{ height: 30, width: 30, marginTop: 2.5 }}
                        alt="File"
                      />
                      <p style={fileTextStyle}>File</p>
                    </div>
                    <DeleteIcon
                      className="icon"
                      style={{
                        height: "20px",
                        width: "20px",
                        alignSelf: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!window.confirm("Elimina immagine")) return;
                        this.setState({ file: undefined });
                      }}
                    />
                  </div>
                )}
                <br />
                <Button
                  callback={async () => {
                    const { titolo, descrizione, data, file } = this.state;
                    const cookies = new Cookies();
                    const token = cookies.get("token", { path: "/" });
                    const username = cookies.get("username", { path: "/" });
                    const userId = cookies.get("userId", { path: "/" });

                    // Debug e controllo token
                    console.log("Debug uploadCompiti:", {
                      username,
                      token: token ? "presente" : "mancante",
                      userId,
                    });

                    if (!token || !username) {
                      alert("Sessione scaduta. Effettua nuovamente il login.");
                      window.location.href = "/";
                      return;
                    }

                    if (!titolo.trim()) {
                      this.setState({ alertTitolo: true });
                    } else if (!descrizione.trim()) {
                      this.setState({ alertDescrizione: true });
                    } else if (!data) {
                      this.setState({ alertData: true });
                    } else {
                      // Stima della dimensione del file in base al base64 (se presente)
                      let sizeInMB = 0;
                      if (file) {
                        const base64Size = file.length * 0.75;
                        sizeInMB = base64Size / 1024 / 1024;
                      }

                      // Verifica validità del token prima dell'upload
                      this.setState({
                        isLoading: true,
                        loadingMessage:
                          sizeInMB > 5
                            ? `Caricamento compito (${sizeInMB.toFixed(
                                1
                              )} MB)... Attendere prego.`
                            : "Caricamento compito in corso...",
                      });

                      const tokenValid = await checkTokenService(
                        username,
                        token
                      );
                      if (!tokenValid) {
                        this.setState({
                          isLoading: false,
                          isUploading: false,
                          uploadProgress: 0,
                        });
                        alert(
                          "Sessione scaduta. Effettua nuovamente il login."
                        );
                        window.location.href = "/";
                        return;
                      }

                      this.setState({ isUploading: true, uploadProgress: 0 });

                      sendCompiti(
                        username,
                        token,
                        this.props.corso.id,
                        titolo,
                        descrizione,
                        data,
                        file,
                        userId,
                        (progress) => {
                          console.log(`[UploadCompiti] Progress: ${progress}%`);
                          this.setState({ uploadProgress: progress });
                        }
                      )
                        .then((resp) => {
                          this.setState({
                            isLoading: false,
                            isUploading: false,
                            uploadProgress: 100,
                            loadingMessage: "Caricamento in corso...",
                          });
                          console.log("Risposta sendCompiti:", resp);
                          if (resp && resp.status === "success") {
                            alert("Compito assegnato con successo");
                            this.setState({ visible: false });
                            this.props.onClose();
                          } else {
                            console.error("Risposta del server:", resp);
                            alert(
                              "Errore nel caricamento del file: " +
                                (resp?.error || "Errore sconosciuto")
                            );
                          }
                        })
                        .catch((error) => {
                          this.setState({
                            isLoading: false,
                            isUploading: false,
                            uploadProgress: 0,
                            loadingMessage: "Caricamento in corso...",
                          });
                          console.error(
                            "Errore durante il caricamento:",
                            error
                          );
                          alert(
                            error.message || "Errore nel caricamento del file"
                          );
                        });
                    }
                  }}
                  title={"Carica"}
                ></Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const input = {
  width: "300px",
  padding: "10px",
  borderLeft: 0,
  borderTop: 0,
  borderRight: 0,
  borderBottom: "1px solid darkgrey",
};

const textarea = {
  ...input,
  height: "100px",
  resize: "none",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};

const alertStyle = {
  marginTop: 5,
  borderRadius: 10,
  width: 300,
  height: 32,
  padding: 5,
  color: "#c41e3a",
  fontWeight: "bold",
};

const fileStyle = {
  width: "300px",
  height: 45,
  boxShadow: "0px 1px 3px lightgrey",
  backgroundColor: "#F3F3F3",
  padding: "5px 20px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  borderRadius: 10,
  cursor: "pointer",
  marginBottom: 16,
  marginLeft: 5,
};

const fileTextStyle = {
  fontWeight: "bold",
  color: "darkgrey",
  marginLeft: 20,
  marginTop: 9,
  textTransform: "none",
};

const windowTitle = {
  color: "darkgrey",
  fontSize: 30,
  fontWeight: "bold",
  fontFamily: "Teko",
  textAlign: "left",
  marginLeft: 5,
};

const closeBtn = {
  position: "absolute",
  cursor: "pointer",
  right: 10,
  top: 10,
  padding: 10,
  zIndex: 999,
};

const container = {
  position: "fixed",
  display: "block",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  minWidth: "100%",
  minHeight: "100%",
  backgroundColor: "#3C3C3C4D",
  overflowY: "scroll",
  overflowX: "hidden",
  zIndex: 999,
};

const mainClass = {
  paddingBottom: 10,
  position: "absolute",
  left: "calc((100% - 400px)/2",
  top: "100px",
  minWidth: "350px",
  maxHeight: 550,
  width: "350px",
  background: "white",
  padding: "20px",
  boxShadow: "0px 2px 10px darkgrey",
  borderRadius: "10px",
};
